import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { FINANCE_PERMISSIONS } from '@modules/finance/constants';

import {
  FINANCE_MONTH_DOWNLOAD_REPORT_MUTATION_KEY,
  FINANCE_MONTH_DOWNLOAD_REPORT_URL,
} from '../constants';

export default function useDownloadFinanceMonthReportMutation(date: Ref<string>): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [FINANCE_MONTH_DOWNLOAD_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      FINANCE_MONTH_DOWNLOAD_REPORT_URL,
      {
        ...payload,
        report: {
          date: date.value,
        },
      },
      { permission: FINANCE_PERMISSIONS.REPORT },
    ),
  });
}
